/*
 * Copyright (c) 2023. World Wide Generation Ltd
 */

import { RootInitiativeData } from './initiative';
import { CanUpgradeDetails } from './subscriptions';

export interface UpgradeProps {
  rootOrg: RootInitiativeData;
  toggle: () => void;
  upgradeDetails: CanUpgradeDetails;
  title?: string;
}

export enum CompanySettingsPages {
  Details = 'details',
  AccountManagement = 'account-management',
}
